import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Target, MagnifyingGlass, ClockCounterClockwise, BookmarkSimple, Gear, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/app", label: "Search", icon: MagnifyingGlass, end: true },
  { to: "/app/history", label: "History", icon: ClockCounterClockwise },
  { to: "/app/saved", label: "Saved", icon: BookmarkSimple },
  { to: "/app/settings", label: "Settings", icon: Gear },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-60 border-r border-zinc-200 bg-white flex flex-col fixed h-screen">
        <button
          onClick={() => navigate("/app")}
          data-testid="logo-home"
          className="flex items-center gap-2 px-5 h-16 border-b border-zinc-200 hover:bg-zinc-50 transition-colors"
        >
          <div className="w-7 h-7 rounded-md bg-zinc-900 flex items-center justify-center">
            <Target size={16} weight="bold" color="#fff" />
          </div>
          <span className="font-head font-bold tracking-tight">HireReach</span>
        </button>

        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 h-10 rounded-md text-sm font-medium transition-colors ${
                  isActive ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"
                }`
              }
            >
              <n.icon size={18} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-zinc-200">
          <div className="flex items-center gap-3 px-2 py-2">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-8 h-8 rounded-full object-cover" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-zinc-200 flex items-center justify-center text-xs font-semibold">
                {user?.name?.[0] || "U"}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{user?.name}</p>
              <p className="text-xs text-zinc-400 truncate">{user?.email}</p>
            </div>
          </div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="mt-1 w-full flex items-center gap-3 px-3 h-9 rounded-md text-sm text-zinc-600 hover:bg-zinc-100 transition-colors"
          >
            <SignOut size={18} /> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-60 min-h-screen">{children}</main>
    </div>
  );
}
